export const ACTION_TYPE = {
  UPLOAD_FILE_MULTI_REQUEST: "upload-file/UPLOAD_FILE_MULTI_REQUEST",
  UPLOAD_FILE_MULTI_SUCCESS: "upload-file/UPLOAD_FILE_MULTI_SUCCESS",
  UPLOAD_FILE_MULTI_ERROR: "upload-file/UPLOAD_FILE_MULTI_ERROR",
};
